import brandPortalMessages from "@faire/web-api/routes/brand-portal/messages";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../../common/Bold";
export var SWFShipped = function SWFShipped() {
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "ha1Fly",
    defaultMessage: [{
      "type": 0,
      "value": "Cette commande a été marquée comme expédiée. Vous ne pouvez donc plus modifier les informations de suivi. Si une étiquette Expédier avec Faire a été utilisée ou si le colis est déjà en transit, vous ne pouvez pas annuler l'étiquette pour en créer une nouvelle. Contactez notre équipe d'assistance pour obtenir de l'aide afin que votre commerçant reçoive les bonnes informations."
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "u33Ad+",
    defaultMessage: [{
      "type": 0,
      "value": "Vous pouvez également envoyer un message au commerçant sur "
    }, {
      "children": [{
        "type": 0,
        "value": "Faire Messenger"
      }],
      "type": 8,
      "value": "ButtonFormatting"
    }, {
      "type": 0,
      "value": " afin de lui fournir les informations d'expédition correctes."
    }],
    values: {
      ButtonFormatting: function ButtonFormatting(chunks) {
        return FaireMessagingFormatting(chunks);
      }
    }
  })));
};
var FaireMessagingFormatting = function FaireMessagingFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalMessages(),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};